import React, { useMemo, useState } from "react";
import Navbar from "../component/Navbar";
import BigLogo from '../assets/image/BigLogo.png'
import SmallLogo from '../assets/image/SmallLogo.png'
import BigPic from '../assets/image/BigPic.png'
import BigPic1 from '../assets/image/land-back2.png'
import {BsDot} from 'react-icons/bs'
import {HiPaperAirplane} from 'react-icons/hi'
import telegarmLogo from '../assets/image/telegram.svg';
import instegramLogo from '../assets/image/instegram.svg';
import twitterLogo from '../assets/image/twitter.svg';
import youtubeLogo from '../assets/image/youtube.svg';
import facebookLogo from '../assets/image/facebook.svg';
import SlideComponent from '../component/SlideComponent';

function Landing() {
  return (
    <div className='flex flex-col items-center bg-[#111111] overflow-hidden'>
      <Navbar/>
      <div className='w-full land-container flex  justify-center items-center py-28'>
        <div className='max-w-[1440px] flex flex-col lg:flex-row items-center'>
          <div className='p-10 w-1/2 flex-auto lg:pr-0'>
            <img src={BigLogo}></img>
          </div>
          <div className='w-full md:w-[550px] h-auto md:h-[550px] flex flex-col justify-center p-10 relative lg:pl-0'>
            <div className='w-full flex justify-center'><div className='text-white text-[100px] md:text-[170px] font-normal font-ruthie text-center absolute top-0'>Feel the</div></div>
            <div className='text-[28px] md:text-[40px] text-[#f9fd11] font-black font-lato text-center mt-[80px] tracking-widest'>LION DANCE</div>
            {/* <div className='w-full flex justify-center mt-10'><img className='w-[352px]' src={adverLogo}></img></div> */}
            <div className='text-[18px] text-[#f9fd11] font-normal font-lato text-center mt-4 uppercase tracking-widest'>traditional dance in Chinese culture and other Asian countries in which performers mimic a lion's movements in a lion costume to bring good luck and fortune.</div>
            <div className='w-full flex justify-center mt-8'>
              <button className='bg-[#f9fd11] text-black text-[18px] font-semibold px-5  py-2'>BUY $LALA</button>
            </div>
          </div>
        </div>
      </div>
      <div className='w-full py-24 md:pt-40  bg-black '>
        <div className='text-white w-full text-center text-[48px] font-bold mb-16 font-jakarta'>Meet Our Lion Team</div>
        <SlideComponent></SlideComponent>
      </div>
      <div className='w-full flex justify-center items-center py-14 px-0 lg:px-20'>
        <div className='max-w-[1440px] py-10 relative w-full bg-[#111111]'>
          <div className='text-[28px] md:text-[70px] font-bold text-white w-full text-center'>代币经济学</div>
          <div className='text-[28px] md:text-[70px] font-bold text-white w-full text-center mt-4'>Tokenomics</div>
          <div className='flex-col w-full mt-20 space-y-4 z-10 relative'>
            <div className='flex-col space-y-4 font-semibold '>
              <div className='text-[20px] md:text-[45px] text-white w-full text-left flex items-center tracking-wide'><BsDot className="text-white"></BsDot>总供应量 / Total Supplies</div>
              <div className='ml-12 text-[16px] md:text-[30px] text-white w-full text-left'>1.000.000.000 $LALA</div>
            </div>
            <div className='flex-col space-y-4 font-semibold '>
              <div className='text-[20px] md:text-[45px] text-white w-full text-left flex items-center tracking-wide'><BsDot className="text-white"></BsDot>税收 / Tax</div>
              <div className='ml-12 text-[16px] md:text-[30px] text-white w-full text-left'>1% for BUY/SELL</div>
            </div>
            <div className='flex-col space-y-4 font-semibold '>
              <div className='text-[20px] md:text-[45px] text-white w-full text-left flex items-center tracking-wide'><BsDot className="text-white"></BsDot>智能合约 / Smart contract</div>
              <div className='ml-12 text-[16px] md:text-[30px] text-white w-full text-left'>burned & renounced</div>
            </div>
          </div>
          <div className='absolute bottom-0 right-0 z-0 w-3/4'>
            <img src={BigPic}></img>
          </div>
        </div>
      </div>
      <div className='w-full land-container1 flex flex-col md:grid md:grid-cols-3 h-[100vh]'>
        <div className='h-1/3 md:cols-span-1 md:h-full flex flex-col justify-end p-12 space-y-5 border-r-white border-r-[1px]  border-b-[1px] md:border-b-[0px] border-opacity-50'>
          <div className='text-white text-[35px]'>UTUBE</div>
          <div className='text-white'>Lorem Ipsum is simply dummy text the priinting & type setting industry.</div>
          <button className='px-5 py-2 w-[188px] bg-[#f9fd11] text-black text-[18px] font-semibold'>LIKE PAGE</button>
        </div>
        <div className='h-1/3 md:cols-span-1 md:h-full flex flex-col justify-end p-12 border-r-white border-r-[1px]  border-b-[1px] md:border-b-[0px] border-opacity-50'>
          <div className='text-white text-[35px]'>INSTEGRAM</div>
        </div>
        <div className='h-1/3 md:cols-span-1 md:h-full flex flex-col justify-end p-12'>
          <div className='text-white text-[35px]'>TWITTER</div>
        </div>
      </div>
      <div className='w-full relative bg-[#ADAF45] flex flex-col px-5 mt-[300px]'>
        <div className='shadow-md drop-shadow-lg -mt-[300px] relative bg-[#141414] h-[600px] flex justify-center items-center'>
          <img className=" max-h-[600px]" src={BigPic1}></img>
          <div className='w-full h-full absolute top-0 left-0 p-10 flex flex-col items-start'>
            <div className='w-[320px]'>
              <div className='text-[#ffb800] tracking-wide text-xl text-center'>BOOKING</div>
              <div className='text-white text-[42px] text-center'>BOOK YOUR <br></br> TICKET</div>
            </div>
            <div className='w-full px-0 py-20 md:px-24'>
              <div className='flex flex-col space-y-2 md:space-y-0 md:flex-row'>
                <div className='w-full md:w-1/2 px-5'>
                  <div className='flex border-b-[1px] border-white text-white space-x-2'>
                    <div>YOUR&nbsp;NAME</div>
                    <input className='bg-transparent border-none outline-none w-full'></input>
                  </div>
                </div>
                <div className='w-full md:w-1/2 px-5'>
                  <div className='flex border-b-[1px] border-white text-white space-x-2'>
                    <div className='block md:hidden'>YOUR&nbsp;EMAIL</div>
                    <input className='bg-transparent border-none outline-none w-full'></input>
                    <div className='hidden md:block'>YOUR&nbsp;EMAIL</div>
                  </div>
                </div>
              </div>
              <div className='w-full px-5 mt-10'>
                <div className='flex flex-col items-start w-full border-b-[1px] border-white '>
                <div className='text-white'>MESSAGE</div>
                <textarea className='bg-transparent outline-none border-none w-full h-[115px] text-white'>

                </textarea>
                </div>
                <div className='w-full flex justify-center mt-5'>
                  <button className='px-5 py-2  bg-[#f9fd11] text-black text-[18px] font-semibold'>SEND</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className=' w-full  flex flex-col justify-center items-center space-y-4 mt-10'>
          <div className='flex items-center space-x-2'><img src={SmallLogo}></img><div className='text-white text-[35px]'>Lion Dance</div></div>
          <div className='flex flex-wrap space-x-10 text-[18px] text-black border-none'>
            <div >HOME</div>
            <div >ABOUT US</div>
            <div >DISCOGRAPHY</div>
            <div >EVENT</div>
            <div >ARTIST</div>
            <div >NEWS</div>
          </div>
          <div className='text-[20px] tracking-wider uppercase text-center'>
            subscribe for our <br/> Tradition!
          </div>
          <div className='flex w-full md:w-[449px]'>
            <div className='border-b-[1px] border-black flex w-full space-x-4'>
              <div className=''>Enter&nbsp;Email</div>
              <input className=' w-full border-none bg-transparent outline-none'></input>
            </div>
            <div className=''>
              <HiPaperAirplane className='text-black rotate-90'></HiPaperAirplane>
            </div>
          </div>
          <div className='flex space-x-10 mt-10 pb-5'>
            <div><img className='w-[10] h-[10]' src={facebookLogo}></img></div>
            <div><img className='w-[10] h-[10]' src={instegramLogo}></img></div>
            <div><img className='w-[10] h-[10]' src={youtubeLogo}></img></div>
            <div><img className='w-[10] h-[10]' src={twitterLogo}></img></div>
            <div><img className='w-[10] h-[10]' src={telegarmLogo}></img></div> 
          </div>
          <div className='border-t-[1px] border-black w-full flex justify-between pb-5'>
            <div className='uppercase'>@ all rights reserved.</div>
            <div className='uppercase flex items-center'>
              <div>terms & conditions</div>
              <BsDot></BsDot>
              <div>privacy policy</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Landing;